import React from "react";

import { ArtyBitsIcon, WarningIcon } from "../Icons";
import { BannerPriority, BannerProps } from "./Banner.types";
import * as S from "./Banner.styles";

/**
 * Banner component for displaying important messages
 */
export const Banner = ({
  priority = BannerPriority.information,
  text,
  closeBanner,
  className,
  includeIcons = true
}: BannerProps) => {
  return (
    <S.Layout priority={priority} className={className}>
      {includeIcons &&
        (priority === BannerPriority.information ||
        priority === BannerPriority.activity ? (
          <ArtyBitsIcon themeFill={"var(--icon-night-fill,var(--night))"} />
        ) : (
          <WarningIcon
            fill={`${
              priority === "critical"
                ? "var(--theme-neutral-0)"
                : "var(--theme-neutral-900)"
            }`}
          />
        ))}
      <S.TextContainer>{text}</S.TextContainer>
      {priority === BannerPriority.information && <ArtyBitsIcon version="v2" />}
      <S.ButtonContainer priority={priority}>{closeBanner}</S.ButtonContainer>
    </S.Layout>
  );
};
